import { render, staticRenderFns } from "./slide-verify.vue?vue&type=template&id=486967d5&scoped=true&"
import script from "./slide-verify.vue?vue&type=script&lang=js&"
export * from "./slide-verify.vue?vue&type=script&lang=js&"
import style0 from "./slide-verify.vue?vue&type=style&index=0&id=486967d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486967d5",
  null
  
)

export default component.exports